import React from "react";
import {Box, Container, Stack, Typography, useTheme} from "@mui/material";
import GithubLogo from "../../assets/github.svg?react";
import XLogo from "../../assets/x.svg?react";
// import DiscordLogo from "../../assets/discord.svg?react";
// import TwitterLogo from "../../assets/twitter.svg?react";
// import MediumLogo from "../../assets/medium.svg?react";
// import LinkedInLogo from "../../assets/linkedin.svg?react";
import SvgIcon from "@mui/material/SvgIcon";

import LogoFullLight from "../../assets/topo.png";
import LogoFullDark from "../../assets/topo.png";
import {Link} from "../../routing";

const socialLinks = [
  {title: "Git", url: "https://github.com/Topo-Labs", icon: GithubLogo},
  {title: "X", url: "https://x.com/TopoNetwork", icon: XLogo},
  // {
  //   title: "Discord",
  //   url: "https://discord.com/invite/aptosnetwork",
  //   icon: DiscordLogo,
  // },
  // {title: "X", url: "https://x.com/aptoslabs/", icon: TwitterLogo},
  // {title: "Medium", url: "https://aptoslabs.medium.com/", icon: MediumLogo},
  // {
  //   title: "LinkedIn",
  //   url: "https://www.linkedin.com/company/aptoslabs/",
  //   icon: LinkedInLogo,
  // },
];

export default function Footer() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      component="footer"
      sx={{
        mt: {xs: 2.5, md: 8},
        py: 4,
        background: theme.palette.tokens.background.secondary,
      }}
    >
      <Container maxWidth={false} sx={{px: {xs: 2, md: 5}}}>
        <Stack
          direction="row"
          spacing={{xs: 2, md: 4}}
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Stack spacing={1.25} alignItems="flex-start">
            <Stack direction="row" alignItems="center" spacing={1}>
              <Link
                to="https://topo.club/"
                target="_blank"
                title="Topo Labs"
                sx={{
                  display: "block",
                  transition: "opacity 0.2s",
                }}
              >
                <Box
                  component="img"
                  src={isDark ? LogoFullDark : LogoFullLight}
                  alt="Topo"
                  sx={{
                    height: "2rem",
                    display: "block",
                  }}
                />
              </Link>
              <Typography fontSize="1.13rem" fontWeight={600}>
                Topo Explorer
              </Typography>
            </Stack>
            <Typography
              variant="body2"
              sx={{
                textAlign: "left",
                fontSize: "12px",
                fontWeight: 400,
                color: theme.palette.tokens.text.tertiary,
              }}
            >
              © {new Date().getFullYear()} Topo Labs. All Rights Reserved.
            </Typography>
          </Stack>

          <Stack spacing={1.5} alignItems="flex-end">
            <Stack direction="row" spacing={2.5}>
              {socialLinks.map((link) => (
                <Link
                  key={link.title}
                  to={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={link.title}
                  color="inherit"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "text.primary",
                    "&:hover": {color: "primary.main"},
                  }}
                >
                  <SvgIcon
                    component={link.icon}
                    inheritViewBox
                    sx={{fontSize: "2rem"}}
                  />
                </Link>
              ))}
            </Stack>

            <Stack
              direction="row"
              spacing={3}
              sx={{
                "& a": {
                  fontSize: "0.875rem",
                  fontWeight: 400,
                  color: "text.secondary",
                  textDecoration: "none",
                  "&:hover": {color: "text.primary"},
                },
              }}
            >
              <Link to="https://topo.club/terms" target="_blank">
                Terms
              </Link>
              <Link to="https://topo.club/privacy" target="_blank">
                Privacy
              </Link>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
